export const state = () => ({
  profile: null,
})

export const getters = {
  getProfile(state) {
    return state.profile
  },
  getLoyaltyTier(state) {
    return state.profile
      ? state.profile.loyalty_tier_membership.loyalty_tier
      : null
  },
}

export const mutations = {
  setProfile(state, profile) {
    state.profile = profile
  },
  addToPoints(state, points) {
    state.profile.points_approved += parseInt(points)
  },
}

export const actions = {
  async init({ commit }, customer) {
    try {
      const profile = getters.getProfile
      if (!profile.email && customer && customer.email) {
        await this.$axios
          .post('/api/loyalty/customer', {
            email: customer.email,
            locale: this.app.i18n.locale,
          })
          .catch((error) => {
            return error
          })
          .then((result) => {
            if (result.data) {
              if (result.data.customers.length && result.data.customers[0]) {
                commit('setProfile', result.data.customers[0])
              }
            } else {
              throw new Error('No result data for loyalty customer')
            }
          })
      }
    } catch (e) {
      this.app.$sentryException(e, {
        source: 'loyaltylion',
        level: 'warning',
        extra: 'Store - callLoyaltyLion - init(): ' + e,
      })
      throw new Error(e)
    }
  },
  async updateCustomer({ commit }, payload) {
    try {
      await this.$axios
        .post('/api/loyalty/customer/update', {
          payload,
          locale: this.app.i18n.locale,
        })
        .catch((error) => {
          return error
        })
        .then((result) => {
          if (result.data.customer) commit('setProfile', result.data.customer)
        })
    } catch (e) {
      this.app.$sentryException(e, {
        source: 'loyaltylion',
        level: 'warning',
        extra: 'Store - callLoyaltyLion - updateCustomer()',
      })
      throw new Error(e)
    }
  },
  async awardPoints({ commit }, payload) {
    try {
      await this.$axios
        .post('/api/loyalty/customer/awardPoints', {
          payload,
          locale: this.app.i18n.locale,
        })
        .catch((error) => {
          return error
        })
        .then((result) => {
          commit('addToPoints', payload.points)
        })
    } catch (e) {
      this.app.$sentryException(e, {
        source: 'loyaltylion',
        level: 'warning',
        extra: 'Store - callLoyaltyLion - awardPoints()',
      })
      throw new Error(e)
    }
  },
  clear({ commit }) {
    try {
      commit('setProfile', null)
    } catch (e) {
      this.app.$sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Store - clear()',
      })
      throw new Error(e)
    }
  },
}
